import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

class ConnectionPointNameDisplayController implements angular.IComponentController {
    readonly connectionPoint: any;
    readonly isEditMode: boolean;

    static $inject = [];
}

export const wtConnectionPointNameDisplay: ComponentDefinition = {
    componentId: 'wtConnectionPointNameDisplay',
    controller: ConnectionPointNameDisplayController,
    template: require('./connectionPointNameDisplay.component.html'),
    controllerAs: 'vm',
    bindings: {
        connectionPoint: '<',
        isEditMode: '<?'
    }
};
